import React from 'react'
import ReactDOM from 'react-dom'
import { Switch, Route, BrowserRouter as Router } from 'react-router-dom'

import '@livechat/design-system/dist/design-system.css'
import './index.css'

import { Fullscreen, MessageBox, ChatWidget, ChatDetails } from './apps'
import { ErrorBoundary } from './components'
import { initSentry, initFullStory } from './utils'

initSentry()
initFullStory()

const App = () => {
  return (
    <ErrorBoundary>
      <Router>
        <Switch>
          <Route exact path="/">
            <Fullscreen />
          </Route>
          <Route path="/message-box">
            <MessageBox />
          </Route>
          <Route path="/chat-widget">
            <ChatWidget />
          </Route>
          <Route path="/chat-details">
            <ChatDetails />
          </Route>
          <Route path="/public">
            <ChatWidget />
          </Route>
        </Switch>
      </Router>
    </ErrorBoundary>
  )
}

ReactDOM.render(<App />, document.getElementById('root'))
